import React from 'react';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../mock';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-[#F1EFE8] to-[#E8EBE5] py-20 lg:py-28 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#0F6E56]/5 rounded-bl-[100px] hidden lg:block"></div>
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-[#5DCAA5]/5 rounded-tr-[100px] hidden lg:block"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-[#2C2C2A] leading-[1.1] tracking-tight">
              Your independence, our commitment.
              <span className="text-[#0F6E56] block mt-4">Empowering ability, every day.</span>
            </h1>

            <p className="text-lg lg:text-xl text-[#6B6B69] leading-relaxed max-w-xl">
              Dedicated to helping you achieve your personal goals with tailored support services through the NDIS.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                className="group inline-flex items-center justify-center space-x-2 px-8 py-4 bg-[#0F6E56] text-white rounded-full hover:bg-[#0d5c48] transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <span>Get Care and Support</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>

            {/* Trust indicators */}
            <div className="flex items-center space-x-6 pt-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#0F6E56]">3+</div>
                <div className="text-sm text-[#6B6B69]">Years Supporting<br/>Clients</div>
              </div>
              <div className="w-px h-12 bg-[#E4E1D8]"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#0F6E56]">24/7</div>
                <div className="text-sm text-[#6B6B69]">Support</div>
              </div>
              <div className="w-px h-12 bg-[#E4E1D8]"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#0F6E56]">NDIS</div>
                <div className="text-sm text-[#6B6B69]">Registered</div>
              </div>
            </div>
          </div>

          {/* Right Image with overlay card */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-white">
              <img
                src="https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/rr53p8x2_landing-page-1.png"
                alt="Empowering Lives with Compassionate Disability Support"
                className="w-full h-auto object-contain"
              />
            </div>
            
            {/* Floating accessibility card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs hidden lg:block">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0F6E56]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-[#0F6E56]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-[#2C2C2A] mb-1">WCAG 2.1 AA</h3>
                  <p className="text-sm text-[#6B6B69]">Fully accessible platform designed for everyone</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;